import * as AlgoSettingsActions from './external-access.actions';
import { Action, createReducer, on } from '@ngrx/store';

export type State = { projects: null | string[] };

const initialState: State = {
  projects: null
};

const pluginExternalAccessReducer = createReducer(
  initialState,
  on(AlgoSettingsActions.ClearState, (): State => initialState),
  on(AlgoSettingsActions.GetProjectNamesSuccess, (state, { projects }): State => ({ ...state, projects }))
);

export const reducer = (state: State, action: Action): State => pluginExternalAccessReducer(state, action);
